import { TextInput } from "@carbon/react";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";

import { useT } from "src/internationalization";

import { ConfListMultiPickerFormField } from "./ConfListMultiPickerFormField";
import { RuleFormData } from "./useRuleDefinition";

type RuleTextInputOrMultiSelectProps = {
  index: number;
  id: string;
  methods: UseFormReturn<RuleFormData, undefined, RuleFormData>;
};
export const RuleTextInputOrMultiSelect: React.FC<RuleTextInputOrMultiSelectProps> = ({
  index,
  methods,
  id,
}) => {
  const t = useT();
  const { control, formState } = methods;
  const confListCode =
    useWatch({ control, name: "criteria" })[index].property?.confListCode || null;
  const disabled = !(
    formState?.dirtyFields?.criteria?.[index].operator &&
    formState?.dirtyFields?.criteria?.[index].property
  );

  return (
    <Controller
      name={`criteria.${index}.value`}
      control={control}
      render={({ field, fieldState }) => {
        return confListCode ? (
          <ConfListMultiPickerFormField
            id={id}
            disabled={disabled}
            index={index}
            method={methods}
            field={field}
          />
        ) : (
          <TextInput
            id={`value-${id}`}
            labelText={t("page.rules.modal.create.form.filters.value.label")}
            placeholder={t("page.rules.modal.create.form.filters.value.placeholder")}
            value={Array.isArray(field.value) ? "" : field.value}
            onChange={(e) => {
              field.onChange(e);
            }}
            disabled={disabled}
            invalid={!!fieldState.error}
            invalidText={fieldState.error?.message}
          />
        );
      }}
    />
  );
};
